<template>
  <main>
    <md-card>
      <md-steppers md-active-step="start" md-alternative md-linear>
        <md-step id="email" md-label="メール認証"></md-step>
        <md-step id="apply" md-label="必須事項の入力"></md-step>
        <md-step id="start" md-label="無料トライアルご利用開始"></md-step>
        <md-step id="contract" md-label="本契約の手続き"></md-step>
        <md-step id="startService" md-label="ご利用開始"></md-step>
      </md-steppers>

      <md-card-header>
        <div class="md-title">本契約の手続き</div>
      </md-card-header>

      <div class="md-layout">
        <div class="md-layout-item md-size-10 md-small-size-100"></div>
        <div class="md-layout-item md-size-80 md-small-size-100">
          <md-card-content>
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-small-size-100">
                <p>本契約を行う場合は、下記「本契約へ進む」ボタンをクリックしてください。</p>
                <p class="text-error">
                  ※本契約には登記情報提供サービスのIDが必要です。<br>
                  ※本契約の手続きは、平日8:30〜22:55・土日祝日8:30〜17:55の受付となります。
                </p>
              </div>
            </div>
          </md-card-content>
        </div>
      </div>

      <div class="md-layout">
        <div class="md-layout-item md-size-15 md-small-size-100"></div>
        <div class="md-layout-item md-size-70 md-small-size-100">
          <md-card-content class="md-description">
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-large-size-20 md-layout"></div>
              <div class="md-layout-item md-large-size-60 md-layout md-alignment-center-center">
                <span>必須</span>
                <md-button @click="toPayment" class="md-raised">
                  <span>ご利用上の注意</span>
                  <md-icon>arrow_right</md-icon>
                </md-button>
              </div>
              <div class="md-layout-item md-large-size-20 md-layout"></div>
            </div>
          </md-card-content>
        </div>
      </div>

      <div class="md-layout">
        <div class="md-layout-item md-size-15 md-small-size-100"></div>
        <div class="md-layout-item md-size-70 md-small-size-100">
          <md-card-actions>
            <div class="md-layout md-alignment-center">
              <!--キャンペーン用-->
              <md-button class="md-primary md-raised md-alignment-center-center" @click="showPaymentCaution = true" v-if="onBusinessTime && !showedPayment">
                <span>本契約へ進む</span>
                <md-icon>arrow_right</md-icon>
              </md-button>
              <router-link :to="{name: 'BackendUserPaymentContract'}" class="md-primary md-raised md-alignment-center-center" tag="md-button" v-else-if="onBusinessTime && showedPayment">
                <span>本契約へ進む</span>
                <md-icon>arrow_right</md-icon>
              </router-link>

              <!--Tサービス停止時用-->
              <md-button class="md-primary md-raised md-alignment-center-center" disabled="disabled" v-else>
                <span>本契約へ進む</span>
                <md-icon>arrow_right</md-icon>
              </md-button>
            </div>
          </md-card-actions>
        </div>
      </div>

      <div class="md-layout">
        <div class="md-layout-item md-size-10 md-small-size-100"></div>
        <div class="md-layout-item md-size-80 md-small-size-100">
          <h4>トライアルのご利用について</h4>
          <ul>
            <li>「本契約の手続き」を行わない限り無料トライアルは15日間で終了し、自動で本契約へ移行することはございませんので、無料トライアルの解約の手続きは必要ございません。<br>
              <span class="md-caption">※ただし、下記表のいずれかのご利用回数が上限に達した場合は、その時点でトライアルが終了いたします。</span>
            </li>
            <li>本契約後は、無料トライアルでご利用されたIDとパスワードを管理者アカウントとして引き続きご利用いただけます。また、無料トライアル中に取得した登記情報は引き継がれます。<br>
              <span class="md-caption">※シカクマップIDが同じ場合に限ります。</span></li>
          </ul>
        </div>
      </div>

      <!-- 無料トライアルについて -->
      <div class="md-layout md-alignment-center mb-40" v-show="loaded">
        <div class="md-layout-item md-size-90 md-small-size-100">
          <plan-table v-on:loading-complete-plan="onLoadingCompletePlan" :show-current-value="true"></plan-table>
        </div>
      </div>

      <!--必ず利用規約をお読みください-->
      <md-dialog :md-active.sync="showPaymentCaution">
        <md-dialog-title>必ずご利用上の注意をお読みください</md-dialog-title>
        <md-dialog-actions>
          <md-button class="md-primary" @click="showPaymentCaution = false">閉じる</md-button>
        </md-dialog-actions>
      </md-dialog>
    </md-card>
  </main>
</template>

<script>
  import FlashMessage                                   from '../../../components/FlashMessage';
  import PlanTable                                      from "../../../components/frontend/PlanTable";
  import CommonMixin                                    from '../../../mixins/commonMixin';
  import Common                                         from '../../../modules/common';

  export default {
    name      : "UserContractFlow",
    components: {FlashMessage, PlanTable},
    mixins    : [CommonMixin],
    data      : () => ({
      trial             : {},
      main              : {},
      loaded            : false,
      showPaymentCaution: false,
      showedPayment     : false,
    }),
    mounted   : function () {
      Common.onBusinessTime().then(value => this.onBusinessTime = value);
    },
    methods   : {
      onLoadingCompletePlan(plan) {
        this.trial  = plan.trial;
        this.main   = plan.main;
        this.loaded = true;
      },
      toPayment() {
        window.open('/payment', '_blank');
        this.showedPayment = true;
      }
    },
  }
</script>

<style lang="scss" scoped>
  .md-description {
    font-size: 1.1rem;

    .md-layout-item:nth-child(2) {
      color: #fff;
      font-size: 90%;
      background-color: #ff5252;
      height: 70px;
    }
  }

  .md-card-actions {
    margin-top: 30px;

    .md-button {
      height: 52px;
    }
  }

  .text-error {
    color: #ff5252;
  }

  .md-pt-0 {
    padding-top: 0px;
  }

  .md-pb-0 {
    padding-bottom: 0px;
  }
</style>
